// src/Components/Unauthorized.js
import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Components/Logo.jpeg';

const Unauthorized = () => (
  <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'Segoe UI' }}>
    <img src={Logo} alt="Company Logo" style={{ width: '120px', marginBottom: '1.5rem' }} />
    <h2 style={{ color: '#444' }}>Thank you for visiting</h2>
    <p style={{ fontSize: '1.1rem', color: '#666', marginBottom: '1.5rem' }}>
      Please log in to continue accessing the  features.
    </p>
    <Link to="/login" style={{
      padding: '10px 20px',
      background: 'linear-gradient(to right, #007bff, #00c6ff)',
      color: 'white',
      textDecoration: 'none',
      borderRadius: '6px',
      fontWeight: '500',
      fontSize: '1rem'
    }}>
      Login
    </Link>
  </div>
);

export default Unauthorized;
